export default (sessionData: any) => localStorage.setItem('sessionData', JSON.stringify(sessionData))
